var _rect, _rect2, _circle, _circle2, _circle3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgError404 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 160,
  height: 131,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 129,
  x: 1,
  y: 1,
  stroke: "#000",
  strokeWidth: 2,
  rx: 3
})), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
  width: 158,
  height: 18,
  x: 1,
  y: 1,
  stroke: "#000",
  strokeWidth: 2,
  rx: 3
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 147,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 136,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
  cx: 125,
  cy: 10,
  r: 2,
  stroke: "#000",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65 41 45 61M45 41l20 20M115 41 95 61M95 41l20 20M38 78h83"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeWidth: 2,
  d: "M88.5 78h33v12.5c0 9.113-7.387 16.5-16.5 16.5s-16.5-7.387-16.5-16.5z"
})));
export { SvgError404 as ReactComponent };
export default __webpack_public_path__ + "b4e26d6ca973a46f9f1523f1b12deb04.svg";